import { ComponentType } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { IconProps } from '@/components/icons/ChevronDownIcon';
import { ActionCard } from '@/components/layout/ActionCard/ActionCard';
import { COLORS } from '@/styles/tokens/colors';

export interface AddNewAnythingActionCardProps {
  description: React.ReactNode;
  Icon: ComponentType<IconProps>;
  onClick: () => void;
}

export function AddNewAnythingActionCard({
  description,
  Icon,
  onClick,
}: AddNewAnythingActionCardProps) {
  return (
    <ActionCard
      sx={{ flex: 1, minWidth: 180 }}
      description={description}
      icon={<Icon size={70} color={COLORS.TEXT.SECONDARY} />}
      actions={
        <Button onClick={onClick} variant="primary" size="sm" fullWidth>
          Add new
        </Button>
      }
    />
  );
}
